export default {
	methods: {
		validaTempoDeVoo(tipo) {
			// NAVEGAÇÃO
			if (tipo == 'NA') {
				if (this.form.hora_navegacao != '00:00') {
					this.form.navegacao = this._timeToDecimal(
						'28/01/1991 00:00',
						'28/01/1991 ' + this.form.hora_navegacao
					)
					// primeiro tempo é o ser validado
					if (
						this._validaTempoMenor(
							this.tempoVooPiloto,
							this.form.hora_navegacao
						)
					) {
						this.erro.navegacao = this._traducao(
							'global',
							'valorMaiorQueTempoPiloto'
						)
					} else {
						this.erro.navegacao = ''
					}
				}
			}

			if (tipo == 'D') {
				if (this.form.hora_vfr_diurno != '00:00') {
					this.form.vfr_diurno = this._timeToDecimal(
						'28/01/1991 00:00',
						'28/01/1991 ' + this.form.hora_vfr_diurno
					)
				} else {
					this.form.vfr_diurno = '0.0'
				}
			}

			if (tipo == 'N') {
				if (this.form.hora_vfr_noturno != '00:00') {
					this.form.vfr_noturno = this._timeToDecimal(
						'28/01/1991 00:00',
						'28/01/1991 ' + this.form.hora_vfr_noturno
					)
				} else {
					this.form.vfr_noturno = '0.0'
				}
			}

			if (tipo == 'IFR') {
				if (this.form.hora_ifr != '00:00') {
					this.form.ifr = this._timeToDecimal(
						'28/01/1991 00:00',
						'28/01/1991 ' + this.form.hora_ifr
					)

					// primeiro tempo é o ser validado
					if (this._validaTempoMenor(this.tempoVooPiloto, this.form.hora_ifr)) {
						this.erro.ifr = this._traducao('global', 'valorMaiorQueTempoPiloto')
					} else {
						this.erro.ifr = ''
					}
				} else {
					this.form.ifr = '0.0'
					this.erro.ifr = ''
				}
			}

			if (tipo == 'VFR') {
				if (this.form.hora_vfr != '00:00') {
					this.form.vfr = this._timeToDecimal(
						'28/01/1991 00:00',
						'28/01/1991 ' + this.form.hora_vfr
					)

					// primeiro tempo é o ser validado
					if (this._validaTempoMenor(this.tempoVooPiloto, this.form.hora_vfr)) {
						this.erro.vfr = this._traducao('global', 'valorMaiorQueTempoPiloto')
					} else {
						this.erro.vfr = ''
					}
				} else {
					this.form.vfr = '0.0'
					this.erro.vfr = ''
				}
			}

			if (tipo == 'IFRS') {
				if (this.form.hora_ifr_simulado != '00:00') {
					this.form.ifr_simulado = this._timeToDecimal(
						'28/01/1991 00:00',
						'28/01/1991 ' + this.form.hora_ifr_simulado
					)

					if (
						this._validaTempoMenor(this.tempoVooPiloto, this.form.ifr_simulado)
					) {
						this.erro.ifr_simulado = this._traducao(
							'global',
							'valorMaiorQueTempoPiloto'
						)
					} else {
						this.erro.ifr_simulado = ''
					}
				} else {
					this.form.ifr_simulado = '0.0'
					this.erro.ifr_simulado = ''
				}
			}
		},

		validaNull(valor) {
			if (_.isNil(valor)) {
				return ''
			}

			return valor
		},

		carregaHorimetro() {
			bus.$emit('load-in', {
				text: this._traducao('global', 'carregandoHorimetro')
			})

			this._getHorimetro((retorno) => {
				bus.$emit('load-out')
				if (retorno) {
					this.form.horimetro_inicial = Number(
						Number(retorno.horimetro).toFixed(1)
					)
					this.form.horimetro_inicial_manutencao = Number(
						Number(retorno.horimetro_manutencao).toFixed(1)
					)
				}
			}, this.aeronave.id)
		},

		carregaCamposOrdem(ordem) {
			this.cargas = ordem.aeronave[0].itens_carga.map((carga) => {
				carga.id = 0
				carga.selecionado = false
				carga.id_passageiro =
					carga.id_passageiro == '0' ? '' : carga.id_passageiro
				carga.tipo_embalagem =
					carga.tipo_embalagem == '0' ? '' : carga.tipo_embalagem
				carga.descricaoErro = ''
				carga.id_pass_erro = ''
				carga.erroEmbalagem = ''
				carga.pesoErro = ''
				carga.erro_tipo_carga = ''
				return carga
			})

			ordem.aeronave = ordem.aeronave.map((item) => {
				item._aero = _.find(this.aeronaves, (o) => {
					return o.id == item.id_aeronave
				})

				return item
			})

			// se não tiver editando carrega os dados da ordem
			if (!this.edicao) {
				this.qtdEstPassageiros =
					ordem.aeronave[0].quantidade_estimada_passageiros
				if (ordem.aeronave.length > 0) {
					var aero = _.find(ordem.aeronave, (o) => {
						return o.id_aeronave == this.aeronave.id
					})
					// não tem a aeronave selecionada na ordem
					if (_.isNil(aero)) {
						this.aerosImport = ordem.aeronave
						this.$refs.modalAero.modalShow(50)
					} else {
						this.aeronave_import = aero
						if (this.form.tripulacao.length > 0) {
							this.aeronave_import.tripulacao = this.form.tripulacao
							this.aeronave_import.voo_instrucao = this.form.voo_instrucao
							this.carregaDadosAero(true)
						} else {
							this.carregaDadosAero()
						}
					}
				}

				//this.form.base = this.validaNull(ordem.base)

				if (!_.isNil(ordem.id_tipo_missao)) {
					this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
						return o.id == ordem.id_tipo_missao
					})
				} else if (!_.isNil(ordem.tipo_missao)) {
					this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
						return o.descricao == ordem.tipo_missao
					})
				}

				this.form.descricao = this.validaNull(ordem.descricao)
				this.form.missao_inicio =
					ordem.data_inicio != null
						? this._SQLDateToDateTime(
								ordem.data_inicio,
								$sessao.getDateFormat() + ' HH:MM'
						  )
						: ''

				this.form.classificacao =
					ordem.id_classificacao != null
						? this.getClassificacaoById(ordem.id_classificacao)
						: ''

				this.form.subclassificacao =
					ordem.id_subclassificacao != null
						? this.getSubclassificacaoById(ordem.id_subclassificacao)
						: ''

				// if (this.form.subclassificacao.instrucao == '1') {
				// 	this.form.voo_instrucao = '1'
				// } else {
				// 	this.form.voo_instrucao = '0'
				// }

				this.form.houve_contexto = this.validaNull(ordem.houve_contexto)
				if (this.form.houve_contexto != null) {
					for (var i in this.contextos) {
						if (this.contextos[i].id == ordem.id_contexto_operativo) {
							this.form.contexto_operativo = this.contextos[i]
						}
					}
				}

				// orgaos recebidos
				this.form.orgao = []
				_.forEach(ordem.orgao, (org) => {
					var orgao_apoiado = {}
					var orgao = _.find(this.orgaos, (o) => {
						return o.id == org.id
					})
					orgao_apoiado.erroOrgao = ''
					orgao_apoiado.orgao = orgao
					var unidades = []

					_.forEach(org.unidade, (unidade) => {
						var uni = _.find(orgao_apoiado.orgao.unidade, (p) => {
							return p.id == unidade.id
						})
						uni.erroUnidade = ''
						unidades.push({unidade: uni, erroUnidade: ''})
					})

					orgao_apoiado.unidade = unidades
					this.form.orgao.push(orgao_apoiado)
				})
			}
		},

		carregarPassageiro(val, index) {
			if (!val) {
				this.clearPass(index)
				return
			}

			this.validarCPF(val.cpf, index)

			if (this.form.passageiro.length > 0) {
				if (this.form.passageiro[index].id_passageiro == val.id_passageiro) {
					window.bus.$emit('exibir-notificacao', {
						type: 'danger',
						text: this._traducao('global', 'voceJaAddEssePerfil')
					})
				} else {
					this.form.passageiro[index].id = 0
					this.form.passageiro[index].id_passageiro = val.id_passageiro
					this.form.passageiro[index].nome = val.nome
					this.form.passageiro[index].nomeErro = ''
					this.form.passageiro[index].cpf = val.cpf
					this.form.passageiro[index].outro = val.outro 
					this.form.passageiro[index].cpfErro = ''
					this.form.passageiro[index].telefone = val.telefone
					this.form.passageiro[index].telefoneErro = ''
					this.form.passageiro[index].orgao = this.orgaos.find(
						(orgao) => orgao.id == val.id_orgao_apoiado
					)?.descricao
					this.form.passageiro[index].telefone = val.telefone
					this.form.passageiro[index].orgaoErro = ''
					this.form.passageiro[index].cargo = this.listaFuncoesPassageiros.find(
						(funcao) => funcao.id == val.id_funcao
					)?.descricao
					this.form.passageiro[index].cargoErro = ''
					this.form.passageiro[index].tipo_passageiro = val.tipo_passageiro
					this.search = ''
				}
			}

			this.atualizaDb++
		},

		carregaDadosOap() {
			this._axios('Orgao_apoiado/get', 'get', {
				callback: (res) => (this.orgaos = res.lista)
			})
		},

		carregarListaPassageiros() {
			this._httpGet('/Passageiro/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					retorno.lista.map((passageiro) => {
						passageiro.cpf = passageiro.cpf === 'N/A' ? '' : passageiro.cpf 
						passageiro.id_passageiro = passageiro.id
						passageiro.orgao = passageiro.id_orgao_apoiado
						passageiro.peso = parseFloat(passageiro.peso, 2)
						return passageiro
					})
					this.listaPassageiros = retorno
				}
			})
		},

		carregaUnidadesArmazenamento() {
			this._httpGet('/Unidade_armazenamento/get', (retorno) => {
				if (retorno._request && retorno._status) {
					this.unidadesArmazenamento = retorno.lista.map((unidade) => ({
						...unidade,
						quantidade_atual: parseFloat(unidade.quantidade_atual).toFixed(1),
						label: unidade.descricao,
						value: unidade.id
					}))
				}
			})
		},

		listaFuncoes() {
			this._axios('Funcao_bordo/listar', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						retorno.lista.map((item) => (item.excluir = 0))
						this.listaDeFuncoes = retorno.lista.map((item) => {
							item.descricao = item.descricao.toLowerCase()
							return item
						})
						this.funcoesQueAssinam = this.listaDeFuncoes.filter((item) => item.assina_diario == '1')
						this.funcoesQueAssinam = this.funcoesQueAssinam.map((it) => ({...it,
							active: false
						}))
						this.funcaoPrincipal = retorno.lista
							.filter((item) =>
								['piloto em comando', 'piloto em instrução'].includes(
									item.descricao
								)
							)
							.map((fn, index) => {
								fn.voo_instrucao = index
								fn.descricao = fn.descricao.toLowerCase()
								return fn
							})
					} else {
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: this._traducao('global', 'erroConectarServidor')
						})
					}
				}
			})
		},

		getClassificacaoById(id) {
			for (var i in this.classificacoes) {
				if (this.classificacoes[i].id == id) {
					return this.classificacoes[i]
				}
			}
		},

		getSubclassificacaoById(id) {
			for (var i in this.subclassificacoes) {
				if (this.subclassificacoes[i].id == id) {
					return this.subclassificacoes[i]
				}
			}
		},

		clearPass(index) {
			if (this.form.passageiro.length > 0) {
				this.form.passageiro[index].id = 0
				this.form.passageiro[index].id_passageiro = 0
				this.form.passageiro[index].nome = ''
				this.form.passageiro[index].nomeErro = ''
				this.form.passageiro[index].cpf = ''
				this.form.passageiro[index].cpfErro = ''
				this.form.passageiro[index].telefone = ''
				this.form.passageiro[index].telefoneErro = ''
				this.form.passageiro[index].outro = ''
				this.form.passageiro[index].orgao = ''
				this.form.passageiro[index].telefone = ''
				this.form.passageiro[index].orgaoErro = ''
				this.form.passageiro[index].cargo = ''
				this.form.passageiro[index].cargoErro = ''
			}
		},

		addPass(passageiro) {
			var pass = {
				data_nascimento: '',
				idade_aparente: '',
				idadeErro: '',
				sexo: '',
				sexoErro: '',
				tipo: 'P',
				nome: passageiro.nome,
				nomeErro: '',
				orgao: passageiro.orgao,
				orgaoErro: '',
				cargo: passageiro.cargo,
				outro: passageiro.outro, 
				cargoErro: '',
				cpf: passageiro.cpf,
				cpfErro: '',
				telefone: passageiro.telefone,
				telefoneErro: '',
				id_passageiro: passageiro.id_passageiro
			}

			this.form.passageiro.push(pass)
		},

		carregaANAC(lista, id, index) {
			if (id != '') {
				var item = lista.find((o) => {
					return o.id == id
				})

				if (!item) return

				this.form.tripulacao[index].anac = item.codigo_anac
				this.form.tripulacao[index].trigrama = item.trigrama
				this.form.tripulacao[index].nome = item.nome
				this.form.tripulacao[index].base_contratual = item.base_contratual
				this.form.tripulacao[index].status = item.status
			}
			this.atualizaModal++
		},

		carregaANACTrigrama(lista, trigrama, index) {
			if (trigrama) {
				this.form.tripulacao[index].trigrama =
					this.form.tripulacao[index].trigrama.toUpperCase()

				var idx = _.findIndex(lista, (o) => {
					return typeof trigrama == 'string'
						? o.trigrama == trigrama.toUpperCase()
						: o.trigrama == trigrama
				})

				if (idx >= 0) {
					this.form.tripulacao[index].anac =
						lista[idx].codigo_anac != '' ? lista[idx].codigo_anac : 'N/A'
					this.form.tripulacao[index].id_usuario = lista[idx].id_usuario
						? lista[idx].id_usuario
						: lista[idx].id
					this.form.tripulacao[index].nome = lista[idx].nome
					this.form.tripulacao[index].trigrama = lista[idx].trigrama
					this.form.tripulacao[index].base_contratual =
						lista[idx].base_contratual
					this.form.tripulacao[index].status = lista[idx].status
				} else {
					this.form.tripulacao[index].anac = ''
					this.form.tripulacao[index].id_usuario = ''
					this.form.tripulacao[index].nome = ''
					this.form.tripulacao[index].trigrama = ''
					this.form.tripulacao[index].base_contratual = ''
					this.form.tripulacao[index].status = ''
				}
			} else {
				this.form.tripulacao[index].anac = ''
				this.form.tripulacao[index].id_usuario = ''
				this.form.tripulacao[index].trigrama = ''
				this.form.tripulacao[index].nome = ''
				this.form.tripulacao[index].base_contratual = ''
				this.form.tripulacao[index].status = ''
			}
			this.$forceUpdate()
		},

		getANAC(lista, trigrama, index) {
			if (trigrama) {
				var idx = -1

				if (this.utilizaTrigrama) {
					this.form.discrepancia[index].trigrama =
						this.form.discrepancia[index].trigrama.toUpperCase()
					idx = _.findIndex(lista, (o) => {
						return o.trigrama == trigrama.toUpperCase()
					})
				} else {
					idx = _.findIndex(lista, (o) => {
						return o.id_usuario == trigrama
					})
				}

				if (idx >= 0) {
					this.form.discrepancia[index].anac =
						lista[idx].codigo_anac != '' ? lista[idx].codigo_anac : 'N/A'
					this.form.discrepancia[index].id_usuario = lista[idx].id_usuario
					this.form.discrepancia[index].base_contratual =
						lista[idx].base_contratual
					this.form.discrepancia[index].status = lista[idx].status
				} else {
					this.form.discrepancia[index].anac = ''
					this.form.discrepancia[index].id_usuario = ''
					this.form.discrepancia[index].trigrama = ''
					this.form.discrepancia[index].base_contratual = ''
					this.form.discrepancia[index].status = ''
				}
			} else {
				this.form.discrepancia[index].anac = ''
				this.form.discrepancia[index].id_usuario =
					this.form.discrepancia[index].id_usuario == ''
						? ''
						: this.form.discrepancia[index].id_usuario
				this.form.discrepancia[index].base_contratual = ''
				this.form.discrepancia[index].status = ''
			}
		},

		async carregaUsuariosTripulacao(funcao, index, zeraId, carregaAnac) {
			if (funcao == '' || typeof funcao == 'number') {
				funcao =
					this.form.voo_instrucao == 0
						? 'piloto em comando'
						: this.form.tripulacao[index].voo_instrucao == ''
						? 'piloto em comando'
						: 'piloto em instrução'
				let indexPiloto = this.funcoesQueAssinam.findIndex((item) => item.descricao === funcao)
				this.funcoesQueAssinam[indexPiloto].active = true
			}

			if (funcao != '') {
				if(Array.isArray(this.funcoesQueAssinam) && this.funcoesQueAssinam.length > 0){
					if(index == 0 && funcao != 'piloto em comando'){
						let indexFuncaoAtiva = this.funcoesQueAssinam.findIndex((item) => item.descricao == funcao);
						if(indexFuncaoAtiva == -1){
							indexFuncaoAtiva = this.funcoesQueAssinam.findIndex((item) => item.descricao === 'piloto em comando');
						} 
						this.funcoesQueAssinam = this.funcoesQueAssinam.map((item, index) => ({
							...item,
							active: index === indexFuncaoAtiva,
						  }));
					} 
				}
				const retorno = await this.getByFuncaoBordo(funcao)
				if (retorno._request && retorno._status) {
					this.form.tripulacao[index].usuarios =
						retorno.lista.length == 0
							? [
									{
										id: '',
										descricao: this._traducao(
											'global',
											'nenhumRegistroEncontrado'
										)
									}
							  ]
							: retorno.lista.map((dadosUsuario) => {
									dadosUsuario.descricao =
										dadosUsuario.trigrama + ' - ' + dadosUsuario.nome
									return dadosUsuario
							  })

					this.form.tripulacao[index].funcao = funcao
					if (zeraId) {
						this.form.tripulacao[index].id_usuario = ''
					}
					if (carregaAnac) {
						this.carregaANAC(
							this.form.tripulacao[index].usuarios,
							this.form.tripulacao[index].id_usuario,
							index
						)
					}
				}
			}
		},

		async getByFuncaoBordo(funcao) {
			return new Promise((resolve) => {
				this._axios('Usuario/get_by_funcao_bordo/' + funcao, 'get', {
					callback: (retorno) => {
						resolve(retorno)
					}
				})
			})
		},

		carregaDadosAero(tripDespacho, showPassageiros = false) {
			//método criado para carregar os tripulantes a partir do despacho caso venha de um despacho(antes estava carregando da ordem de missão)
			if (tripDespacho) {				
				this.form.tripulacao = this.form.tripulacao.map((elem, idx) => {
					elem.erroUsuario = ''
					elem.apresentacao = this._SQLDateToDateTime(
						elem.apresentacao,
						$sessao.getDateFormat() + ' HH:MM'
					)
					elem.erroApresentacao = ''
					elem.anac = 'N/A'
					elem.codigo_ovn = elem.codigo_ovn
					elem.erroOVN = ''
					elem.erroFuncao = ''
					elem.tempoOvn = 0
					elem.uso_ovn = ''
					elem.id_ovn = ''
					elem.sn_ovn = ''
					elem.erroTempoOvn = ''
					elem.erroUsoOvn = ''
					this.carregaUsuariosTripulacao(elem.funcao, idx, false, true)
					return elem
				})
			} else {
				if (!_.isNil(this.aeronave_import.voo_instrucao)) {
					this.form.voo_instrucao = this.aeronave_import.voo_instrucao
				}
				var verificaPiloto =
					this.form.voo_instrucao == 0
						? 'PILOTO EM COMANDO'
						: 'PILOTO EM INSTRUÇÃO'
				// tem tripulacao
				if (Array.isArray(this.aeronave_import.tripulacao) && this.aeronave_import.tripulacao.length > 0) {
					var indexPilot = -1
					_.forEach(this.aeronave_import.tripulacao, (trip, index) => {
						if (trip.funcao.toUpperCase() == verificaPiloto) {
							this.form.tripulacao[0].id_usuario = trip.id_usuario
							this.form.tripulacao[0].erroUsuario = ''
							this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(
								trip.apresentacao,
								$sessao.getDateFormat() + ' HH:MM'
							)
							this.form.tripulacao[0].erroApresentacao = ''
							this.form.tripulacao[0].codigo_ovn = trip.codigo_ovn
							this.form.tripulacao[0].erroOVN = ''
							this.form.tripulacao[0].uso_ovn = ''
							this.form.tripulacao[0].sn_ovn = ''
							this.form.tripulacao[0].erroTempoOvn = ''
							this.form.tripulacao[0].tempoOvn = 0
							this.form.tripulacao[0].erroUsoOvn = ''

							this.form.tripulacao[0].funcao = trip.funcao.toLowerCase()
							this.carregaUsuariosTripulacao(trip.funcao, 0, false, true)

							indexPilot = index
						}
					})
					if (indexPilot >= 0) {
						this.aeronave_import.tripulacao.splice(indexPilot, 1)
					}
					let indexFuncaoAtiva = this.funcoesQueAssinam.findIndex((item) => item.descricao == this.form.tripulacao[0].funcao);
					if (indexFuncaoAtiva === -1) {
					  indexFuncaoAtiva = this.funcoesQueAssinam.findIndex((item) => item.descricao === 'piloto em comando');
					}
					this.funcoesQueAssinam[indexFuncaoAtiva].active = true;
					// pega todos os outros tripulantes
					this.form.tripulacao.splice(1, this.form.tripulacao.length - 1)

					_.forEach(this.aeronave_import.tripulacao, (trip, index) => {
						this.form.tripulacao.push({
							id_usuario: trip.id_usuario,
							erroUsuario: '',
							funcao: trip.funcao,
							anac: '',
							apresentacao: this._SQLDateToDateTime(
								trip.apresentacao,
								$sessao.getDateFormat() + ' HH:MM'
							),
							erroApresentacao: '',
							codigo_ovn: trip.codigo_ovn,
							usuarios: [],
							erroFuncao: '',
							erroOVN: '',
							erroIdOvn: '',
							erroIdOvn: '',
							tempoOvn: 0,
							uso_ovn: '',
							id_ovn: '',
							sn_ovn: '',
							erroTempoOvn: '',
							erroUsoOvn: ''
						})

						this.carregaUsuariosTripulacao(
							trip.funcao,
							this.form.tripulacao.length - 1,
							false,
							true
						)
					})
				}
			}
			if (this.aeronave_import.carga == '1') {
				this.form.carga = this.aeronave_import.carga
				this.form.descricao_carga = this.aeronave_import.descricao_carga
				this.form.peso_carga = this.aeronave_import.peso
				this.form.carga_liquida = this.aeronave_import.carga_liquida
			} else {
				this.escolheCarga(this.aeronave_import)
			}

			this.form.base = this.aeronave_import.base
				? this.aeronave_import.base
				: this.aeronave_import.base_aeronave

			if (!_.isNil(this.aeronave_import.trecho)) {
				this.escolhePassageiro(this.aeronave_import, showPassageiros)
			} else {
				this.form.passageiro = []
			}
		},

		escolheCarga(aeronave) {
			if (!Array.isArray(aeronave.carga)) {
				return
			}
			const cargaArray = aeronave.carga === null ? [] : aeronave.carga
			for (let i = 0; i < cargaArray.length; i++) {
				this.cargas[i] = {
					tipo_carga: aeronave.carga[i].tipo_carga,
					descricao_tipo_carga: aeronave.carga[i].descricao_tipo_carga,
					descricao: aeronave.carga[i].descricao,
					peso: aeronave.carga[i].peso,
					carga_fragil: aeronave.carga[i].carga_fragil,
					carga_liquida: aeronave.carga[i].carga_liquida,
					carga_perigosa: aeronave.carga[i].carga_perigosa,
					altura: aeronave.carga[i].altura,
					comprimento: aeronave.carga[i].comprimento,
					largura: aeronave.carga[i].largura,
					volume: aeronave.carga[i].volume,
					descricaoErro: '',
					pesoErro: '',
					erro_tipo_carga: ''
				}
			}
		},

		escolhePassageiro(aeronave, showPassageiros = false) {
			if (aeronave.passageiro.length > 0) {
				var passageiros = []

				_.forEach(aeronave.passageiro, (p) => {
					if (this._idCliente == 62 && !showPassageiros) {
						this.addPass(p)
					} else {
						p.selecionado = false

						if (passageiros.length == 0) {
							passageiros.push(p)
						} else {
							var tem = false
							for (var i in passageiros) {
								if (
									passageiros[i].nome == p.nome &&
									passageiros[i].orgao == p.orgao &&
									passageiros[i].cargo == p.cargo
								) {
									tem = true
									break
								}
							}

							if (!tem) {
								passageiros.push(p)
							}
						}
					}
				})

				// se exisitir passageiros a serem selecionados exibe modal
				if (this._idCliente != 62 && passageiros.length > 0) {
					this.passageirosSelecao = passageiros
					this._exibeModal('modal-ordem-escolha-passageiros', 70)
				}
			} else {
				if (this.aeronave_import.trecho.length > 0) {
					// importa os passagueiros do trecho
					_.forEach(this.aeronave_import.trecho[0].passageiro, (p) => {
						this.addPass(p)
					})
				}
			}
		},

		// FILTA AS CIDADES DE UM ESTADO
		carregaCidades(callback, idEstado) {
			this._httpGet(
				'/Cidade/get_cidade_by_id_estado/' + idEstado,
				(retorno) => {
					if (retorno._request && retorno._status) {
						retorno.lista = retorno.lista.map((t) => {
							t.descricao = t.descricao.toUpperCase()
							return t
						})
						callback({lista: retorno.lista})
					} else if (!retorno._status) {
						callback({lista: []})
					} else {
						callback({lista: []})
					}
				}
			)
		},

		carregaSubClassificacao(item) {
			this.form.subclassificacao = ''

			if (item.id != null) {
				this.loadSub = true

				// SUBs
				this._httpGet(
					'/Classificacao/get_subclassificacao/' + item.id,
					(retorno) => {
						if (retorno._request && retorno._status) {
							this.loadSub = false
							this.subclassificacoes = retorno.lista.map((item) => {
								item._descricao =
									item.subclassificacao + ' - ' + item.subcategoria
								return item
							})

							// verifica se tem sub e seta ela depois de carregar
							if (!_.isNil(item.id_sub)) {
								for (var i in retorno.lista) {
									if (retorno.lista[i].id == item.id_sub) {
										this.form.subclassificacao = retorno.lista[i]
										break
									}
								}
							}
						}
					}
				)
			}
		}
	}
}
